/**
 * Warns when a media element cannot be seeked properly.
 * Written from scratch for Steve.AI.
 */

const alreadyWarned = {};

export const warnAboutNonSeekableMedia = (ref, type) => {
  if (ref === null) return;
  if (ref.seekable.length === 0) return;
  if (ref.seekable.length > 1) return;
  if (alreadyWarned[ref.src]) return;

  const range = { start: ref.seekable.start(0), end: ref.seekable.end(0) };

  if (range.start === 0 && range.end === 0) {
    const msg = `The media ${ref.src} cannot be seeked. The media resource may still be loading or the format does not support seeking.`;

    if (type === 'console-error') {
      console.error(msg);
    } else if (type === 'console-warning') {
      console.warn(`The media ${ref.src} does not support seeking. Rendering will work, but preview playback may be inaccurate.`);
    } else {
      throw new Error(msg);
    }

    alreadyWarned[ref.src] = true;
  }
};
